import React from "react";
import { Link } from "react-router-dom";
import { Icon } from "@iconify/react/dist/iconify.js";
import PublicSEO from "../components/public/PublicSEO";
import { useAuth } from "../context/AuthContext";

const AccessDeniedPage = () => {
  const { isAuthenticated, getRoles } = useAuth();
  const multiRole = isAuthenticated() && getRoles().length > 1;

  return (
    <section className="auth bg-base d-flex flex-wrap">
      <PublicSEO
        title="Accesso non consentito"
        description="Non hai i permessi per accedere a questa pagina."
        canonicalPath="/access-denied"
        noIndex
      />
      <div className="auth-right py-32 px-24 d-flex flex-column justify-content-center w-100">
        <div className="max-w-464-px mx-auto w-100 text-center">
          <div className="mb-40">
            <div className="w-120-px h-120-px bg-danger-subtle rounded-circle d-flex align-items-center justify-content-center mx-auto mb-24">
              <Icon icon="ri-folder-lock-line" className="text-danger-main text-4xl" />
            </div>
            <h2 className="mb-16">Accesso non consentito</h2>
            <p className="text-secondary-light mb-32">
              Non hai i permessi per questa pagina
              {multiRole ? ", oppure stai usando un'altra area del tuo account." : '.'}
            </p>
            <div className="d-flex flex-column flex-sm-row gap-2 justify-content-center">
              {multiRole && (
                <Link to="/app/scegli-area" className="btn btn-primary">
                  Cambia area
                </Link>
              )}
              {isAuthenticated() ? (
                <Link to="/app" className="btn btn-outline-secondary">
                  Torna all&apos;app
                </Link>
              ) : (
                <Link to="/login" className="btn btn-primary">
                  Vai al login
                </Link>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AccessDeniedPage;
